import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDownload = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2071 12.3788V1.79297H12.2071V12.3788L16.5 8.08586L17.9142 9.50008L11.2071 16.2072L4.5 9.50008L5.91421 8.08586L10.2071 12.3788ZM3 18.0001H19V20.0001H3V18.0001Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDownload);

export default ForwardRef;
